import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const DesktopNavContainer = styled.div`
    position: fixed;
    width: 100%;
    background-color: ${ds.brand('white')};    
    z-index: 101;
    transition-duration: .3s;
    
    ${media.desktop`
      ${({ scrollDirection }) => (`
        top: ${(scrollDirection === 'bottom' ? '0' : ds.get('navSection.navHeight'))};
        z-index: ${(scrollDirection === 'bottom' ? '101' : '99')};
        height: ${ds.get('navSection.navHeight')};
      `)}
    `}
`;

export default DesktopNavContainer;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/DesktopNavContainer.jsx